export enum StreamingStatus {
    Active = 'active',
    Completed = 'completed',
}
